<template lang="pug">
  .column.width-100
    hidden-form-input(
      type='text'
      name='password'
      :value='value'
      @input='updateValue'
      :placeholder='$t("register.passwordPlaceholder")'
      :inputError='showErrors && validations.$invalid'
      :filled='filled'
    )
    .column.m-top-1
      .row.middle.m4-bottom-1
        simple-svg(
          :filepath='checkIcon'
          width='18px'
          height='18px'
          :class='{"green-stroke-icon": validateErrors && !lengthError, "gray-icon": !validateErrors || lengthError}'
        )
        span.m-left-1.small-text(:class='{green: !lengthError, "dark-gray": !validateErrors || lengthError}')
          | {{ $t('register.passwordMinLengthError') }}
      .row.middle.m4-bottom-1
        simple-svg(
          :filepath='checkIcon'
          width='18px'
          height='18px'
          :class='{"green-stroke-icon": validateErrors && !upperLowerError, "gray-icon": !validateErrors || upperLowerError}'
        )
        span.m-left-1.small-text(:class='{green: !upperLowerError, "dark-gray": !validateErrors || upperLowerError}')
          | {{ $t('register.passwordUpperLowerError') }}
      .row.middle
        simple-svg(
          :filepath='checkIcon'
          width='18px'
          height='18px'
          :class='{"green-stroke-icon": !numberError, "gray-icon": !validateErrors || numberError}'
        )
        span.m-left-1.small-text(:class='{green: !numberError, "dark-gray": !validateErrors || numberError}')
          | {{ $t('register.passwordNumberError') }}
</template>

<script>
import HiddenFormInput from '@/components/HiddenFormInput.vue'
import checkIcon from '@/assets/ic_check_base.svg'

export default {
  components: { HiddenFormInput },
  props: {
    validations: { type: Object, required: true },
    value: { type: String, required: true },
    filled: { type: Boolean, required: false },
    showErrors: { type: Boolean, required: false }
  },
  data() {
    return {
      checkIcon,
      validateErrors: false
    }
  },
  computed: {
    lengthError() {
      return this.validateErrors && !this.validations.minLength
    },
    upperLowerError() {
      return this.validateErrors && !this.validations.mustHaveUpperAndLower
    },
    numberError() {
      return this.validateErrors && !this.validations.mustHaveANumber
    }
  },
  methods: {
    updateValue(value, name) {
      this.validateErrors = true
      this.$emit('updateValue', value, name)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';
</style>
